import { faro, getWebInstrumentations, initializeFaro, LogLevel } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'
import { useAppSelector } from './store'

export default function FrontendObservability() {
  const sourceRequest = useAppSelector(state => state.sourceRequest)
  // skip if already initialized
  if (faro.api || typeof window === 'undefined' || !sourceRequest?.FARO_ENDPOINT) {
    return null
  }

  try {
    initializeFaro({
      url: sourceRequest?.FARO_ENDPOINT,
      app: {
        name: 'runner-apply',
        version: '1.0.0',
        environment: sourceRequest?.DEPLOY_TARGET || 'local'
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations({ captureConsoleDisabledLevels: [LogLevel.ERROR, LogLevel.DEBUG] }),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation()
      ]
    })
  } catch (error) {
    console.error('Faro initialization failed: ', error)
    return null
  }
  return null
}
